import './lib/hook.js';